export default __webpack_public_path__ + "static/media/small_cv_sample4.bee081bf.png";